import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import WebsiteEventFormContainer from './WebsiteEventFormContainer';


class WebsiteEventFormModal extends Component {
  constructor(props) {
    super(props);

    this.toggleCommonQs = this.toggleCommonQs.bind(this);
    this.state = {
      commonQs: false,
    };
  }

  toggleCommonQs() {
    // console.log('here');
    this.setState(state => ({ commonQs: !state.commonQs }));
  }

  render() {
    const { selectedId, collectRsvps } = this.props;
    const { commonQs } = this.state;
    // console.log(collectRsvps);
    return (
      <div id="event-modal" className="event-modal">
        <div>
          {!commonQs && (
            <div className="modal-header">
              <h3 className="modal-title">{selectedId ? 'Edit' : 'Add'} Event</h3>
            </div>
          )}
          {commonQs && (
            <div className="rsvp-suggestions">
              <div className="modal-header">
                <h3 className="modal-title">Most Common Questions Asked By Zola Couples</h3>
              </div>
            </div>
          )}
          <div className="modal-body">
            <WebsiteEventFormContainer onToggleCommonQs={this.toggleCommonQs} collectRsvps={collectRsvps} />
          </div>
        </div>
      </div>
    );
  }
}

WebsiteEventFormModal.propTypes = {
  selectedId: PropTypes.number,
  collectRsvps: PropTypes.bool
};

const mapStateToProps = state => ({
  selectedId: state.website.entities.selectedEntityId,
});

export default connect(
  mapStateToProps
)(WebsiteEventFormModal);



/** WEBPACK FOOTER **
 ** ./src/components/manage/common/WebsiteEventFormModal.jsx
 **/